export enum FormAction {
  CLEAR,
  PREVIEW,
  CANCEL,
  CHANGE,
  AGREE_AND_SEND,
  NEW_ORDER,
  OPEN_ORDER_STATUS
}

